import { render, staticRenderFns } from "./LeaveButton.vue?vue&type=template&id=63c1cb8e&scoped=true&"
import script from "./LeaveButton.vue?vue&type=script&lang=js&"
export * from "./LeaveButton.vue?vue&type=script&lang=js&"
import style0 from "./LeaveButton.vue?vue&type=style&index=0&id=63c1cb8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1cb8e",
  null
  
)

export default component.exports